import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { ButtonGroup } from "@components";
import { TableColumn } from "./TableColumn";

import { useAcr } from "@hooks/HRM/acr/useAcrList";

export const AcrListTable = () => {
  const [activeStatus, setActiveStatus] = useState<number | null>(0);

  const { t } = useTranslation();
  const { acrList, pagination, handleQuery } = useAcr();
  const { total } = pagination || {};

  const modifiedData = acrList?.map((acr) => ({
    employeeID: acr.employee?.id,
    acrID: acr?.id,
    ...acr.employee,
    ...acr,
  }));

  const filterButtons = t("ACR_LIST.TABLE.ACTION_BUTTONS", {
    returnObjects: true,
  }) as string[];

  const btnGroupAction = (index: number) => {
    setActiveStatus(index);
    switch (index) {
      case 0:
        handleQuery({
          isActiveEmployee: true,
          eligible: null,
        });
        break;
      case 1:
        handleQuery({
          isActiveEmployee: true,
          eligible: true,
        });
        break;
      case 2:
        handleQuery({
          isActiveEmployee: true,
          eligible: false,
        });
        break;
      case 3:
        handleQuery({
          isActiveEmployee: false,
          eligible: null,
        });
        break;
      default:
        handleQuery({
          isActiveEmployee: null,
          eligible: null,
        });
        break;
    }
  };

  return (
    <Table
      columns={TableColumn(t) as any}
      rows={modifiedData}
      header={{
        badge: {
          label: `${total || 0}`,
          size: "sm",
          type: "primary",
        },
        title: t("ACR_LIST.TABLE.HEADER"),
      }}
      headerExtension={{
        leftComponents: [
          <ButtonGroup
            key="btn-group"
            btnGroupData={filterButtons}
            activeState={activeStatus}
            action={btnGroupAction}
          />,
        ],
      }}
      pagination={{
        activePage: pagination?.page,
        totalPage: Math.ceil(total / pagination?.size),
        onClick: (currentPage: number) =>
          handleQuery({
            page: currentPage,
          }),
      }}
    />
  );
};
